import { create } from "zustand";

export const useUser = create((set, get) => ({
  username: localStorage.getItem("username") || "",
  formData: {},
  exporterMasterId: null,
  exporterCustomerid: null,
  isRequiredFieldFilled: false,
  isDataFetched: false,
  loading: false,
  importerMasterId: null,
  trigger: null,
  importTrigger: null,
  filterTrigger: 0,
  eximData : null,
  setFilterTrigger: () =>
    set((state) => ({ filterTrigger: state.filterTrigger + 1 })),

  currentTabType: null, // ⭐ ADD
  setCurrentTabType: (
    currentTabType // ⭐ ADD
  ) => set({ currentTabType }),
  setValueGloabal: null,
  markDirtyExternal: null,

  // Functional setter for formData like React's prev => ...
  setFormData: (updater) =>
    set((state) => ({
      formData:
        typeof updater === "function" ? updater(state.formData) : updater,
    })),
  setMarkDirtyExternal: (fn) => set({ markDirtyExternal: fn }),

  setUsername: (username) => set({ username }),
  setExporterMasterId: (exporterMasterId) => set({ exporterMasterId }),
  setImporterMasterId: (importerMasterId) => set({ importerMasterId }),
  setExporterCustomerid: (exporterCustomerid) => set({ exporterCustomerid }),
  setEximData : (eximData) => set({ eximData }),
  setIsRequiredFieldFilled: (isRequiredFieldFilled) =>
    set({ isRequiredFieldFilled }),
  setIsDataFetched: (isDataFetched) => set({ isDataFetched }),
  setLoading: (loading) => set({ loading }),
  setTrigger: (trigger) => set({ trigger }),
  setImportTrigger: (importTrigger) => set({ importTrigger }),
  setSetValueGlobal: (setValue) =>
    set({
      setValueGlobal: (field, value, options = {}) => {
        // const setValueInternal = get().setValue()
        const markDirtyExternal = get().markDirtyExternal;

        if (!markDirtyExternal) {
          console.error(
            "❌ setValueInternal is not registered yet!",
            markDirtyExternal
          );
          return;
        }

        setValue(field, value, {
          shouldDirty: false,
          shouldValidate: true,
        });

        if (markDirtyExternal) {
          markDirtyExternal(field); // 🔥 IMPORTANT
        }
      },
    }),

  clearAll: () =>
    set({
      formData: {},
      exporterMasterId: null,
      isRequiredFieldFilled: false,
      isDataFetched: false,
      loading: false,
      importerMasterId: null,
      // exporterCustomerid: null,
      // currentTabType: null, // ⭐ RESET
    }),
}));
